import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Tabs, Tab, Button } from '@mui/material';
import ParticipantEntriesPage from './ParticipantEntriesPage';
import ParticipantProfilePage from './ParticipantProfilePage';
import { getParticipantById } from '../api/contests';
import { RenderParticipantPicture } from '../components/Elements';

const ParticipantMasterPage: React.FC = () => {
  const { participantId } = useParams<{ participantId: string }>();
  const [selectedTab, setSelectedTab] = useState(0);
  const [participantName, setParticipantName] = useState<string>('Участник');
  const [profilePicture, setProfilePicture] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (participantId) {
      getParticipantById(participantId)
        .then((data) => {
          setParticipantName(data?.name || 'Неизвестно');
          setProfilePicture(data?.profile_picture || null);
        })
        .catch((error) => console.error('Error fetching participant:', error));
    }
  }, [participantId]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box >
      <Box display="flex" alignItems="center" mb={3}>
        <Button variant="contained" color="primary" onClick={() => navigate(-1)} style={{ marginRight: '10px' }}>
          &lt;&lt;
        </Button>
        <Typography variant="h5" style={{ flexGrow: 1 }} color="primary">
          Участник {participantName}
        </Typography>
        {RenderParticipantPicture(Number(participantId), participantName, profilePicture, 60)}
      </Box>

      <Tabs value={selectedTab} onChange={handleTabChange} indicatorColor="primary" textColor="primary">
        <Tab label="Зарубы участника" />
        <Tab label="Профиль участника" />
      </Tabs>

      {selectedTab === 0 && <ParticipantEntriesPage />}
      {selectedTab === 1 && <ParticipantProfilePage participantId={participantId!} />}
    </Box>
  );
};

export default ParticipantMasterPage;
